import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-analyticsheader',
  templateUrl: './analyticsheader.component.html',
  styleUrls: ['./analyticsheader.component.css']
})
export class AnalyticsheaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
